export * from './ScanToPayFaqEntry';
